import Text from './Text'
import Doc from './Doc'
import {Img, Bg, FaIcon, Action} from './Fields'

export {Text, Img, Bg, FaIcon, Action, Doc}


// WEBPACK FOOTER //
// ./src/fm/field/index.js